<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.gerenteTerritorial.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoGerentesTerritoriais" }'
    )
    .detalhes-gerente-territorial
        h3.detalhes-gerente-territorial__titulo {{ $t('mensagens.gerenteTerritorial.labels.dadosCadastrais') }}
        .detalhes-gerente-territorial__card
            Resume(
                resumeId='detalhes-gerente-territorial',
                :resume='resumeList'
            )
        .footer
            .footer__btn.voltar(@click='irParaGerentesTerritoriais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import services from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'DetalhesGerenteTerritorial',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume'),
        ResumeList: () =>
            import('@/components/contratosOriginacao/formulario/ResumeList')
    },
    props: {
        resume: {
            type: [Array, Object],
            default: () => []
        }
    },
    data() {
        return {
            dados: {},
            gerentesComerciais: []
        };
    },
    computed: {
        resumeList() {
            const keysValids = ['idGerenteComercial', 'idBunge', 'nome'];
            const keyMap = keysValids.map(key => ({
                key,
                label: this.$t(`mensagens.gerenteTerritorial.keys.${key}`),
                value: this.dados[key] || '--'
            }));
            const resume = keyMap.sort(
                (a, b) => keysValids.indexOf(a.key) - keysValids.indexOf(b.key)
            );

            return resume;
        }
    },
    mounted() {
        this.carregarListasGerentes();
    },
    methods: {
        async carregarListasGerentes() {
            this.loadingScreen(true);
            if (this.resume?.idGerenteComercial) {
                await this.buscarGerentesComerciais();
            }
            this.montarDados();
            this.loadingScreen(false);
        },
        montarDados() {
            const gerente = {
                nome: this.resume.nome,
                idBunge: this.resume.idBunge
            };

            if (this.resume?.idGerenteComercial) {
                const idGerenteComercial = this.gerentesComerciais.find(
                    gerente => this.resume.idGerenteComercial === gerente.id
                );

                if (idGerenteComercial) {
                    gerente.idGerenteComercial = idGerenteComercial.nome;
                }
            }
            this.dados = gerente;
        },
        buscarGerentesComerciais() {
            return services.buscarGerentesComerciais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesComerciais = data;
                }
            });
        },
        irParaGerentesTerritoriais() {
            this.$router.push({ name: 'ConfiguracaoGerentesTerritoriais' });
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss" scoped>
.detalhes-gerente-territorial {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
        & + & {
            margin-top: 20px;
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end !important;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
